/* src/app/home-new/home-main-content-section/current-printgroup-status-bar/current-printgroup-status-bar.component.scss */
:host {
  padding: 20px 30px;
  background: rgba(178, 232, 255, 0.2784313725);
  position: sticky;
  top: 0;
  z-index: 5;
  -webkit-backdrop-filter: blur(15px);
  backdrop-filter: blur(15px);
}
:host.menuCollapsed {
  margin-left: 0px;
}
input {
  padding: 5px 5px 5px 5px;
  border: 1px solid #949494;
  border-radius: 10px;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 20px;
  width: 100%;
  max-width: 240px;
  height: fit-content;
}
#popover-button::part(native) {
  padding-inline-end: 0;
}
@media (max-width: 1280px) {
  input {
    max-width: 160px;
  }
}
/*# sourceMappingURL=current-printgroup-status-bar.component-N2N4PSQI.css.map */
